import { createActions, createReducer } from 'reduxsauce'

import EmpenhosContratoService from '../../servicos/EmpenhosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEmpenhosContratoInicio: [],
    buscaEmpenhosContratoSucesso: ['empenhosContrato'],
    buscaEmpenhosContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEmpenhosContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEmpenhosContratoInicio())
        let serv = new EmpenhosContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaEmpenhosContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEmpenhosContratoErro(error)))
    }
}

const buscaEmpenhosContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEmpenhosContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEmpenhosContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.empenhosContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EMPENHOS_CONTRATO_INICIO]: buscaEmpenhosContratoInicio,
    [Types.BUSCA_EMPENHOS_CONTRATO_ERRO]: buscaEmpenhosContratoErro,
    [Types.BUSCA_EMPENHOS_CONTRATO_SUCESSO]: buscaEmpenhosContratoSucesso,
})
